import { ElMessageBox } from 'element-plus/es';
import 'element-plus/es/components/message-box/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "train-wrap"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { learn_sync_user } from '@/api/api-serive';
import { useStore } from 'vuex';
export default /*@__PURE__*/_defineComponent({
  __name: 'TrainDialog',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  emits: ['updateDialog'],
  setup(__props, {
    emit: __emit
  }) {
    const store = useStore();
    //接收父组件传参
    const props = __props;
    //修改父组件参数值
    const emit = __emit;
    const closeDialog = () => {
      emit('updateDialog', false);
    };
    const goToYlx = () => {
      if (!store.state.HomeModule.isLoggedIn) {
        ElMessageBox.confirm('您未登录，请先登录！', '温馨提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          type: 'warning'
        }).then(() => {
          store.commit('SET_LOGIN_REGISTER');
          closeDialog();
        }).catch(() => {});
        return;
      }
      learn_sync_user().then(success => {
        if (200 == success.code) {
          window.open(success.data);
        }
      }).catch(err => {
        console.error(err);
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: props.showDialog,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => props.showDialog = $event),
        onClose: closeDialog,
        "show-close": false,
        width: "500",
        draggable: "",
        center: ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: goToYlx,
          size: "large"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode(" 确认 ")])),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: closeDialog,
          size: "large"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("取消")])),
          _: 1
        })])]),
        default: _withCtx(() => [_cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "train-tips"
        }, "你即将离开本站前往“培训班”，确认前往？", -1))]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});